import {
  StampgetTimeM
} from '@/utils/date.js'
const Nubempty = (val) => {
  return !val || val === '' ? 0 : val
}
const dateFilter = (time) => {
  return StampgetTimeM(time)
}
// 时间原始格式化
const FormatOriginalDate = (value) => {
  if (!value) return ''
  let date = new Date(value)
  // console.log(date)
  let year = date.getFullYear()
  let Month = date.getMonth() + 1
  let day = date.getDate()
  let hours = date.getHours()
  let minute = date.getMinutes()
  let second = date.getSeconds()
  let TIME = year +
    '-' +
    Month +
    '-' +
    day +
    '-' +
    (hours > 9 ? hours : '0' + hours) +
    ':' +
    (minute > 9 ? minute : '0' + minute) +
    ':' +
    (second > 9 ? second : '0' + second)
  return TIME
}
// 原始时间转为时间戳
const FormatOriginalDateTOInt = (value) => {
  if (!value) return -1
  let date = new Date(value)
  return date.getTime()
}
const statusKey = (value) => {
  console.log(value, 'statusvalue')
  const statusKeyObj = {
    1: '预约中',
    2: '投放中',
    3: '已停止'
  }
  if (value) {
    return currentType[value]
  } else {
    return '--'
  }
  switch (value) {
    case 1:
      return '预约中'
    case 2:
      return '投放中'
    case 3:
      return '已停止'
    default:
      break
  }
}
const adLocationKey = (value) => {
  switch (value) {
    case 1:
      return '首页'
    case 2:
      return '设备详情'
    case 3:
      return '充电中'
    case 4:
      return '结算页'
    default:
      break
  }
}
const adCategoryKey = (value) => {
  switch (value) {
    case 1:
      return '闪屏'
    case 2:
      return 'banner'
    case 3:
      return '弹窗'
    default:
      break
  }
}

const adTypeKey = (value) => {
  switch (value) {
    case 1:
      return '链接'
    case 2:
      return '详情图'
    case 3:
      return '不可点击'
    case 4:
      return '跳转小程序'
    default:
      break
  }
}

const adChannelsKey = (value) => {
  switch (value) {
    case 1:
      return 'app'
    case 2:
      return '支付宝小程序'
    case 3:
      return '微信小程序'
    case 4:
      return 'H5'
    default:
      break
  }
}

export {
  Nubempty,
  dateFilter,
  FormatOriginalDate,
  FormatOriginalDateTOInt,
  statusKey,
  adLocationKey,
  adCategoryKey,
  adTypeKey,
  adChannelsKey

}



// WEBPACK FOOTER //
// ./src/filters/index.js